export default "__VITE_ASSET__BM9xO1qs__";